import { Component } from '@angular/core';

import { Showcase } from '../../shared/data/models/collections/showcase';
import { Request } from '../../shared/data/services/request-enum';
import { AbstractLocalizedComponent } from '../../shared/ui/abstract.localized.component';

@Component({
  selector: 'placeme-showcases',
  templateUrl: './showcases.component.html',
  styleUrls: ['./showcases.component.scss'],
})
export class ShowcasesComponent extends AbstractLocalizedComponent {
  showcases: Showcase[];

  protected loadData(locale: string): void {
    this.showcases = null;
    this.collectionsService
      .query<{ showcases: Showcase[] }>(Request.SHOWCASES, { locale })
      .subscribe(data => (this.showcases = data.showcases));
  }
}
